import Column from '@components/column'
import Tab from '@components/tabs'
import Title from '@components/title'
import { Fragment } from 'react'
import TriggerEvents from './trigger-events'
import ReportResponse from './report-response'

const ConditionalEvents = () => {
  const items = [
    // { label: 'Trigger Events', component: TriggerEvents },
    { label: 'Report Reasons', component: ReportResponse },
  ]
  return (
    <Fragment>
      <Column>
        <Title textone="Game Management >" texttwo="Conditional Events" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default ConditionalEvents
